import { Alert } from 'antd';
import styles from './alert-error.module.css';

interface Props {
  message: string;
}

const AlertError = ({ message }: Props): JSX.Element => {
  return <Alert className={styles.errorAlert} title={message} type="error" showIcon />;
};

export default AlertError;
